import { deleteMemberProfile } from "../../Redux/Members/MembersActions";
import Loading from "../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import styles from "./DeleteProfile.module.scss";
import { FaRegEyeSlash } from "react-icons/fa6";
import validator from "../../Util/validator";
import { FaRegEye } from "react-icons/fa6";
import Logo from "../../Assets/Logo.png";
import React, { useState } from "react";

function DeleteProfile() {
  const dispatch = useDispatch<AppDispatch>();
  const { deleteMemberProfileLoading } = useSelector(
    (state: RootState) => state.members,
  );
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const deleteProfileHandler = (e: React.FormEvent) => {
    e.preventDefault();
    const { errors: fieldErrors, isValid } = validator([
      {
        key: "email",
        type: "email",
        value: email,
      },
      {
        key: "password",
        type: "password",
        value: password,
      },
    ]);
    setErrors({ ...errors, ...fieldErrors });
    if (isValid) {
      if (!deleteMemberProfileLoading) {
        dispatch(
          deleteMemberProfile({
            email: email,
            password: password,
          }),
        );
      }
    }
  };
  return (
    <React.Fragment>
      {deleteMemberProfileLoading && <Loading />}
      <div className={styles.mainContainer}>
        <div className={styles.logoContainer}>
          <img src={Logo} alt="Logo" className={styles.logo} />
        </div>
        <form className={styles.formContainer}>
          <div className={styles.headingContainer}>
            <p className={styles.heading}>
              Please enter your email and password to delete your profile
            </p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Email</p>
            <input
              type="email"
              className={styles.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors?.email && <p className={styles.error}>{errors.email}</p>}
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Password</p>
            <div className={styles.passwordInputContainer}>
              <input
                type={showPassword ? "text" : "password"}
                className={styles.input}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
              <button
                type="button"
                className={styles.showPasswordButton}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <FaRegEyeSlash className={styles.icon} />
                ) : (
                  <FaRegEye className={styles.icon} />
                )}
              </button>
            </div>
            <p className={styles.error}>{errors.password}</p>
          </div>
          <div className={styles.buttonContainer}>
            <button
              type="submit"
              className={styles.button}
              onClick={deleteProfileHandler}
            >
              Delete Profile
            </button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}

export default DeleteProfile;
